export default __webpack_public_path__ + "static/media/pilot.27086880.jpg";